module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_17.6773c3fd.jpg";